import { PropsWithChildren } from 'react'

import { Box, Page } from '@revolut-internal/ui-kit'

import { Security } from 'common/security/security'
import { useQueueStatsFilterQuery } from 'modules/Monitoring/api/analytics/queries'
import { useChannel } from 'modules/Monitoring/hooks/useChannel'

import { AdditionalFiltersProvider } from './GlobalFilters/AdditionalFilters/AdditionalFiltersContext'
import { GlobalFilters } from './GlobalFilters/GlobalFilters'

export const Monitoring = ({ children }: PropsWithChildren) => {
  const showAdditionalFilters = Security.canViewAdditionalFilters
  const { channel } = useChannel()
  const { data: additionalFilters, isPending: areAdditionalFiltersPending } =
    useQueueStatsFilterQuery(
      {
        channel,
      },
      { enabled: showAdditionalFilters },
    )

  return (
    <AdditionalFiltersProvider initialFilters={additionalFilters}>
      <Page.Tabs>
        <GlobalFilters
          additionalFilters={additionalFilters}
          showAdditionalFilters={showAdditionalFilters}
          areAdditionalFiltersPending={areAdditionalFiltersPending}
        />
      </Page.Tabs>

      <Page.Main>
        <Box mt="s-16">{children}</Box>
      </Page.Main>
    </AdditionalFiltersProvider>
  )
}
